import { Driver } from 'src/common/external/bambi-api/bambiApi';

import { DriverSkillMap } from './DriverSkillMap';

export function resolveDriverSkills(driver: Driver, skillMap: DriverSkillMap) {
  return Object.keys(skillMap)
    .filter((key) => !!driver[key as keyof Driver])
    .map((key) => skillMap[key]);
}
